<div class="datepicker-form" [formGroup]="form" (focusin)="onFocusIn($event)" (focusout)="onFocusOut($event)">
  <input class="datepicker-input" 
    [owlDateTimeTrigger]="timePicker" 
    matInput [placeholder]="placeholder" readonly  formControlName="timeStr" />
  <input class="datepicker-shadow-input" 
    [owlDateTime]="timePicker"
    [owlDateTimeFilter] 
    formControlName="time"/>
  <owl-date-time #timePicker [pickerType]="'timer'" [hour12Timer]="true"></owl-date-time>
</div>